export default __webpack_public_path__ + "static/mobile-5e80aeca52400183eac63cd73d2995d1.png";